import { AnalyticsType, TStoreSeachViewType } from "./model";

export const viewLocationsPayload = (
  previous_screen: string,
  has_location_services: "True" | "False",
  view_type: TStoreSeachViewType
): AnalyticsType => ({ previous_screen, has_location_services, view_type });
